"use client";

import { c as _c } from "react/compiler-runtime";
import { Calendar } from "@/components/ui/calendar";
import { addCalendarDays, hourlySlots, localDate, type ReleasePlan } from "@/lib/releases/schedule";
const selectClass = "h-10 w-full rounded-md border border-input bg-background px-3 text-sm";
// The calendar represents date parts in the displayed release zone, not a UTC
// instant. Local noon avoids midnight/DST shifts in the browser's date picker.
const calendarDay = (date: string) => new Date(`${date}T12:00:00`);
const dateParts = (day: Date) => [day.getFullYear(), String(day.getMonth() + 1).padStart(2, "0"), String(day.getDate()).padStart(2, "0")].join("-");
export function ReleasePlanFields(t0) {
  const $ = _c(78);
  const {
    plan,
    onChange,
    disabled
  } = t0;
  let t1;
  let t10;
  let t11;
  let t12;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] !== disabled || $[1] !== onChange || $[2] !== plan) {
    let slots = [];
    try {
      slots = hourlySlots(plan.date, plan.timeZone);
    } catch {}
    let T0;
    let t13;
    let t14;
    let t15;
    let t16;
    let t17;
    let t18;
    let t19;
    let t20;
    let t21;
    let t22;
    let tomorrow;
    if ($[15] !== disabled || $[16] !== plan.date || $[17] !== plan.timeZone) {
      const today = localDate(new Date(), plan.timeZone);
      tomorrow = addCalendarDays(today, 1);
      let t23;
      if ($[33] !== plan.date) {
        t23 = plan.date ? calendarDay(plan.date) : undefined;
        $[33] = plan.date;
        $[34] = t23;
      } else {
        t23 = $[34];
      }
      const selected = t23;
      t9 = disabled;
      t10 = "space-y-4";
      if ($[35] !== plan.timeZone) {
        t11 = <p className="text-xs text-muted-foreground">{plan.timeZone} · Hourly · Tomorrow onward</p>;
        $[35] = plan.timeZone;
        $[36] = t11;
      } else {
        t11 = $[36];
      }
      t19 = "group";
      t20 = "Release date";
      t21 = "space-y-1";
      if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
        t22 = <p className="text-sm">Release date</p>;
        $[37] = t22;
      } else {
        t22 = $[37];
      }
      T0 = Calendar;
      t13 = "single";
      t14 = true;
      t15 = selected;
      t16 = selected;
      t17 = calendarDay(today);
      t18 = disabled ? true : {
        before: calendarDay(tomorrow)
      };
      $[15] = disabled;
      $[16] = plan.date;
      $[17] = plan.timeZone;
      $[18] = T0;
      $[19] = t10;
      $[20] = t11;
      $[21] = t13;
      $[22] = t14;
      $[23] = t15;
      $[24] = t16;
      $[25] = t17;
      $[26] = t18;
      $[27] = t19;
      $[28] = t20;
      $[29] = t21;
      $[30] = t22;
      $[31] = t9;
      $[32] = tomorrow;
    } else {
      T0 = $[18];
      t10 = $[19];
      t11 = $[20];
      t13 = $[21];
      t14 = $[22];
      t15 = $[23];
      t16 = $[24];
      t17 = $[25];
      t18 = $[26];
      t19 = $[27];
      t20 = $[28];
      t21 = $[29];
      t22 = $[30];
      t9 = $[31];
      tomorrow = $[32];
    }
    let t23;
    if ($[38] !== onChange || $[39] !== plan || $[40] !== tomorrow) {
      t23 = day => {
        if (!day) {
          return;
        }
        const date = dateParts(day);
        if (date >= tomorrow && date !== plan.date) {
          onChange({
            ...plan,
            date,
            slot: ""
          });
        }
      };
      $[38] = onChange;
      $[39] = plan;
      $[40] = tomorrow;
      $[41] = t23;
    } else {
      t23 = $[41];
    }
    let t24;
    if ($[42] !== T0 || $[43] !== t13 || $[44] !== t14 || $[45] !== t15 || $[46] !== t16 || $[47] !== t17 || $[48] !== t18 || $[49] !== t23) {
      t24 = <T0 mode={t13} required={t14} selected={t15} defaultMonth={t16} today={t17} disabled={t18} onSelect={t23} />;
      $[42] = T0;
      $[43] = t13;
      $[44] = t14;
      $[45] = t15;
      $[46] = t16;
      $[47] = t17;
      $[48] = t18;
      $[49] = t23;
      $[50] = t24;
    } else {
      t24 = $[50];
    }
    if ($[51] !== t19 || $[52] !== t20 || $[53] !== t21 || $[54] !== t22 || $[55] !== t24) {
      t12 = <div role={t19} aria-label={t20} className={t21}>{t22}{t24}</div>;
      $[51] = t19;
      $[52] = t20;
      $[53] = t21;
      $[54] = t22;
      $[55] = t24;
      $[56] = t12;
    } else {
      t12 = $[56];
    }
    t7 = "space-y-1 text-sm";
    t8 = "Release hour";
    t1 = selectClass;
    t2 = "Release hour";
    t3 = plan.slot;
    if ($[57] !== onChange || $[58] !== plan) {
      t4 = e => onChange({
        ...plan,
        slot: e.target.value
      });
      $[57] = onChange;
      $[58] = plan;
      $[59] = t4;
    } else {
      t4 = $[59];
    }
    if ($[60] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <option value="">Choose an hour</option>;
      $[60] = t5;
    } else {
      t5 = $[60];
    }
    t6 = slots.map(_temp);
    $[0] = disabled;
    $[1] = onChange;
    $[2] = plan;
    $[3] = t1;
    $[4] = t10;
    $[5] = t11;
    $[6] = t12;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
    $[13] = t8;
    $[14] = t9;
  } else {
    t1 = $[3];
    t10 = $[4];
    t11 = $[5];
    t12 = $[6];
    t2 = $[7];
    t3 = $[8];
    t4 = $[9];
    t5 = $[10];
    t6 = $[11];
    t7 = $[12];
    t8 = $[13];
    t9 = $[14];
  }
  let t13;
  if ($[61] !== t1 || $[62] !== t2 || $[63] !== t3 || $[64] !== t4 || $[65] !== t5 || $[66] !== t6) {
    t13 = <select className={t1} aria-label={t2} value={t3} onChange={t4}>{t5}{t6}</select>;
    $[61] = t1;
    $[62] = t2;
    $[63] = t3;
    $[64] = t4;
    $[65] = t5;
    $[66] = t6;
    $[67] = t13;
  } else {
    t13 = $[67];
  }
  let t14;
  if ($[68] !== t13 || $[69] !== t7 || $[70] !== t8) {
    t14 = <div><label className={t7}>{t8}{t13}</label></div>;
    $[68] = t13;
    $[69] = t7;
    $[70] = t8;
    $[71] = t14;
  } else {
    t14 = $[71];
  }
  let t15;
  if ($[72] !== t10 || $[73] !== t11 || $[74] !== t12 || $[75] !== t14 || $[76] !== t9) {
    t15 = <fieldset disabled={t9} className={t10}>{t11}{t12}{t14}</fieldset>;
    $[72] = t10;
    $[73] = t11;
    $[74] = t12;
    $[75] = t14;
    $[76] = t9;
    $[77] = t15;
  } else {
    t15 = $[77];
  }
  return t15;
}
function _temp(slot) {
  return <option key={slot.value} value={slot.value}>{slot.label} ({slot.offset})</option>;
}